export default __webpack_public_path__ + "static/media/DNo.20-0.78b82810.jpg";